import { isEqual } from 'lodash-es';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CustomErrorType } from '../entities/common/custom-error-type.entity';
import { RecordSecurityGroups } from '../entities/management/record-security-groups.entity';
import { SecurityGroup } from '../entities/management/security-group.entity';
import { RecordService } from '../record/services/record.service';
import { waitForIndex } from './wait-for-index.helper';

export const WaitForSecurityGroupsUpdate = (
    recordId: string,
    version: number | undefined,
    currentSecurityGroups: SecurityGroup[],
    service: RecordService
): Observable<RecordSecurityGroups> => {
    return service.getSecurityGroups({ Id: recordId, Version: version }).pipe(
        switchMap(result => {
            const securityGroupsIdsInIndex = result.SecurityGroups.filter(
                securityGroup => !securityGroup.IsReadOnly
            ).map(securityGroup => securityGroup.Id);
            const currentSecurityGroupIds = currentSecurityGroups
                .filter(securityGroup => !securityGroup.IsReadOnly)
                .map(securityGroup => securityGroup.Id);

            if (isEqual(securityGroupsIdsInIndex, currentSecurityGroupIds)) {
                return throwError(CustomErrorType.SaveIndexTimeout);
            } else {
                return of(result);
            }
        }),
        waitForIndex()
    );
};
